import { CsokPlusSmallCalculator } from "@component/Csok/CsokPlusSmallCalculator/CsokPlusSmallCalculator";
import csokPlusImg from "@img/landing/lakashitel/csok-plus/children.jpg";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { LandingBottom } from "@landing/components/LandingBottom";
import { InfoCard } from "@ui/components/InfoCard";
import { LandingContainer, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Accordion, Card, Col, Row, Table } from "react-bootstrap";

/**
 * @Routing
 *
 * @title "Otthonteremtési támogatások [YEAR] - Mire vagy jogosult?"
 * @description "Nézd meg, melyik otthonteremtési támogatás (Babaváró, CSOK Plusz, Falusi CSOK, CSOK-hitel) érhető el számodra!"
 * @route "/otthonteremtesi-es-otthonfelujitasi-tamogatasok/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				{this.renderHeader()}
				{this.renderDetails()}

				<LandingBottom tags="lakashitel" />
			</>
		);
	}

	private renderHeader(): ReactNode {
		return (
			<>
				<LandingContainer bgClassName="bg-trianglify-blue bg-border-bottom" bgColor="#1d9bbe" size="lg">
					<Row>
						<Col xs={12} lg={7} className="mt-3 pb-3 align-self-top text-white">
							<h1 className="display-1 display-bold ">Otthonteremtési támogatások 2025</h1>
							<div className="display-4">
								Az otthonteremtési program keretében az alábbi otthonteremtési támogatások és
								kedvezmények érhetők el:
							</div>
							<List itemStyle="tick" variant="gold" className="d-none d-sm-block mt-4">
								<List.Item>
									Maximum <strong>50 millió Ft CSOK</strong> Plusz támogatott kölcsön
								</List.Item>
								<List.Item>
									Maximum <strong>15 millió Ft falusi CSOK</strong> a preferált kistelepüléseken
								</List.Item>
								<List.Item>
									A Falusi CSOK mellé igényelhető maximum <strong>15 millió Ft</strong> kedvezményes,{" "}
									<strong>CSOK</strong> lakáshitel
								</List.Item>
								<List.Item>
									Maximum <strong>11 millió Ft Babaváró</strong> hitel és támogatás
								</List.Item>
								<List.Item>
									Maximum{" "}
									<strong>
										5 millió Ft áfa-visszatérítés a kistelepüléseken zajló lakásépítésre
									</strong>
								</List.Item>
								<List.Item>
									<strong>5 százalékos lakásáfa</strong> az újépítésű lakásokra
								</List.Item>
								<List.Item>
									<strong>5 százalékos lakásáfa-visszatérítés</strong> a kistelepüléseken vásárolt
									újépítésű lakásokra
								</List.Item>
								<List.Item>
									<strong>Illetékmentesség</strong> a CSOK+ és a Falusi CSOK támogatással történő
									lakásvásárlás esetén
								</List.Item>
							</List>
							<List itemStyle="tick" variant="gold" className="d-block d-sm-none mt-4">
								<List.Item>
									Maximum <strong>50 millió Ft CSOK</strong> Plusz támogatott kölcsön
								</List.Item>
								<List.Item>
									Maximum <strong>15 millió Ft falusi CSOK</strong> a preferált kistelepüléseken
								</List.Item>
								<List.Item>
									A Falusi CSOK mellé igényelhető maximum <strong>15 millió Ft</strong> kedvezményes,{" "}
									<strong>CSOK</strong> lakáshitel
								</List.Item>
								<List.Item>
									Maximum <strong>11 millió Ft Babaváró</strong> hitel és támogatás
								</List.Item>
								<List.Item>
									Maximum{" "}
									<strong>
										5 millió Ft áfa-visszatérítés a kistelepüléseken zajló lakásépítésre
									</strong>
								</List.Item>
								<List.Item>
									<strong>5 százalékos lakásáfa</strong> az újépítésű lakásokra
								</List.Item>
								<List.Item>
									<strong>5 százalékos lakásáfa-visszatérítés</strong> a kistelepüléseken vásárolt
									újépítésű lakásokra
								</List.Item>
								<List.Item>
									<strong>Illetékmentesség</strong> a CSOK+ és a Falusi CSOK támogatással történő
									lakásvásárlás esetén
								</List.Item>
							</List>
						</Col>
						<Col xs={12} lg={5} className="align-self-top px-0 py-4">
							<CsokPlusSmallCalculator outsideTitleLink={null} />
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer>
					<InfoCard title="Jobb tudni" variant="retail" className="text-white">
						<Card.Body>
							A 2024. július 1-én induló{" "}
							<a href="/lakasfelujitasi-tamogatas/?link_type=landing-link" target="_blank">
								Otthonfelújítási támogatásról kapcsolódó oldalunkon tájékozódhatsz!
							</a>
						</Card.Body>
					</InfoCard>
				</LandingContainer>
			</>
		);
	}

	private renderDetails(): ReactNode {
		return (
			<>
				<LandingContainer className="details">
					<h2 className="h1 mb-lg-4 mb-md-3 mb-2">
						Az otthonteremtési támogatás és az egyéb lakástámogatások legfontosabb jellemzői
					</h2>
					<div className="table-responsive-lg">
						<Table className="table-striped small">
							<thead className="thead-dark">
								<tr>
									<th>Konstrukció megnevezése</th>
									<th>Milyen lakáscélra fordítható?</th>
									<th>Igényelhető összeg</th>
									<th>Támogatási forma</th>
									<th>Összeg felhasználása</th>
									<th>Település</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="align-middle">
										<strong>CSOK Plusz</strong>
									</td>
									<td className="align-middle">
										- Új lakás vásárlás
										<br />- Használt lakás vásárlás
										<br />- Építkezés
										<br />- Bővítés
									</td>
									<td className="align-middle">Legfeljebb 50 millió Ft</td>
									<td className="align-middle">
										- Kamattámogatás
										<br />- Vissza nem térítendő támogatás
									</td>
									<td className="align-middle">Lakáscélra fordítható</td>
									<td className="align-middle">Bármilyen hazai településen elérhető</td>
								</tr>
								<tr>
									<td className="align-middle">
										<strong>Vagyonátruházási illeték elengedése</strong>
									</td>
									<td className="align-middle">
										- Használt lakás vásárlás
										<br />- Új lakás vásárlás
									</td>
									<td className="align-middle">Vételár 4%-a</td>
									<td className="align-middle">Vissza nem térítendő támogatás</td>
									<td className="align-middle">Lakásvásárlást követő díj elengedése</td>
									<td className="align-middle">
										Bármely hazai településen elérhető Falusi CSOK, vagy CSOK Plusz igénylésekor
									</td>
								</tr>
								<tr>
									<td className="align-middle">
										<strong>
											ÁFA-visszatérítés
											<br />
											(5%)
										</strong>
									</td>
									<td className="align-middle">
										Új lakóház vásárlás; <br />
										Építkezés generálkivitelezővel
									</td>
									<td className="align-middle">Nettó vételár költségek 5%-a</td>
									<td className="align-middle">Vissza nem térítendő támogatás</td>
									<td className="align-middle">Lakáscélra fordítható</td>
									<td className="align-middle">
										Preferált kistelepülésen elérhető Falusi CSOK igénylésekor
									</td>
								</tr>
								<tr>
									<td className="align-middle">
										<strong>
											ÁFA-visszatérítés
											<br />
											(27%)
										</strong>
									</td>
									<td className="align-middle">Építkezés generálkivitelező nélkül</td>
									<td className="align-middle">Nettó költségek 27%-a</td>
									<td className="align-middle">Vissza nem térítendő támogatás</td>
									<td className="align-middle">Szakaszosan az építkezés során</td>
									<td className="align-middle">Preferált kistelepülésen elérhető</td>
								</tr>

								<tr>
									<td className="align-middle">
										<strong>Babaváró hitel</strong>
									</td>
									<td className="align-middle">Bármilyen lakáscél</td>
									<td className="align-middle">Legfeljebb 11 millió Ft</td>
									<td className="align-middle">
										- Vissza nem térítendő támogatás
										<br />- Kamattámogatás{" "}
									</td>
									<td className="align-middle">Lakáscélra fordítható</td>
									<td className="align-middle">Bármilyen hazai településen elérhető</td>
								</tr>
								<tr>
									<td className="align-middle">
										<strong>CSOK hitel</strong>
									</td>
									<td className="align-middle">
										- Új lakás vásárlás
										<br />- Használt lakás vásárlás
										<br />- Építkezés
										<br />- Korszerűsítésre, bővítésre
									</td>
									<td className="align-middle">10/15 millió Ft</td>
									<td className="align-middle">Kamattámogatás</td>
									<td className="align-middle">Lakáscélra fordítható</td>
									<td className="align-middle">
										Preferált kistelepülésen elérhető (kizárólag Falusi CSOK mellé kérhető)
									</td>
								</tr>
							</tbody>
						</Table>
					</div>
					<hr />
				</LandingContainer>
				<LandingContainer className="details">
					<h3>CSOK Plusz</h3>

					<p>Kedvezményes, legfeljebb 3 százalékos kamatozású támogatott kölcsön.</p>
					<p>
						Ha megszületett a futamidő alatt első gyermeked, akkor kérheted a törlesztési kötelezettséged
						egy éves szüneteltetését. (Ez nem jár kamatelengedéssel, az elmaradt kamatot később rendezned
						kell. A moratórium miatt a futamidőt is meghosszabbíthatja a bank, mivel a havi fizetnivaló sem
						emelkedhet meg az eredetihez képest a szüneteltetést követően.)
					</p>
					<p>
						A futamidő alatt született második babától kezdve minden újabb gyermeknél elengednek a fennálló
						tartozásból 10-10 millió Ft-ot.
					</p>

					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<p>
								Az igényelhető támogatott hitel összege függ a jövedelmedtől, az ingatlan értékétől, a
								bank bírálati gyakorlatától és a gyermekek számától is. Ugyanakkor a konkrét lakáscél -
								új, vagy használt lakás vásárlása, építkezés, bővítés - nem befolyásolja az elérhető
								összeget.
							</p>
							<p>
								A CSOK+ maximális összege ugyanis függ a meglévő és vállalt gyermekek számától. (Fontos
								kihangsúlyozni, hogy legalább egy gyermeket vállalni kell a kölcsön igényléséhez,
								anélkül nem lehetsz jogosult a támogatott konstrukcióra.)
							</p>
							<p>A meglévő és vállalt gyermekek száma alapján elérhető maximális összeg:</p>
							<ul>
								<li>Egy gyerek esetén legfeljebb 15 millió Ft lehet a CSOK Plusz összege.</li>
								<li>Kettő gyerek esetén legfeljebb 30 millió Ft lehet a CSOK Plusz összege.</li>
								<li>
									Három, vagy több gyermek esetén legfeljebb 50 millió Ft lehet a CSOK Plusz összege.
								</li>
							</ul>

							<p>
								Ugyanakkor nagyon is lényeges, hogy mennyi ténylegesen a meglévő és vállalt gyerekek
								száma, ennek érzékeltetésére jól szolgál az alábbi táblázat.
							</p>

							<img src={csokPlusImg} alt="CSOK Plusz elérhető támogatás gyermekek számától függően" />
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>A CSOK támogatás kizárólag lakáscélra fordítható.</p>
							<p>A célok a következők lehetnek:</p>
							<ul>
								<li>
									<strong>Új lakás vásárlása:</strong> Kivitelező által értékesítési célra épített
									lakóingatlan vásárlása. Az ingatlannak még nem lehetett magánszemély tulajdonosa.
									(Magánszemély által épített ház nem minősül új lakásnak, akkor sem, ha még nem
									lakott benne senki.)
								</li>
								<li>
									<strong>Építkezés:</strong> Alapozási munkálatoktól kezdődően - vagy meglévő alapra
									- újonnan épített lakóház finanszírozása. Megfelel az emeletráépítés,
									tetőtér-beépítés is, amennyiben 2 új, önállóan forgalomképes és külön helyrajzi
									számon lévő lakást alakítanak ki az új lakrészen.
								</li>
								<li>
									<strong>Használt lakás vásárlás:</strong> Azon lakás vásárlása, amely nem felel meg
									az új lakás feltételeinek.
								</li>
								<li>
									<strong>Bővítés:</strong> Meglévő lakóingatlan legalább egy lakószobával történő
									bővítése.
								</li>
								<li>
									<strong>Használt lakás vásárlásával egyidőben történő bővítés:</strong> A használt
									lakásnak minősülő lakás megvásárlása és annak legalább egy lakószobával történő
									bővítése egyben is finanszírozható.
								</li>
							</ul>
							<p>A támogatás összegéből a vásárlást, építkezést, bővítést lehet megfinanszírozni.</p>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								A CSOK Plusz támogatást meglévő és vállalt gyermekek után lehet igényelni. A kedvezmény
								elnyeréséhez ugyanakkor mindenképpen szükséges legalább egy gyermeket vállanod.
							</p>
							<p>A támogatás szempontjából gyermeknek minősül:</p>
							<ul>
								<li>A várandósság 12. hetét betöltött magzat</li>
								<li>25. életévét be nem töltött, örökbefogadott vagy vér szerinti gyermek</li>
								<li>A 25. életévét betöltött megváltozott munkaképességű személy</li>
								<li>
									A várandósság 12. hetét betöltött magzat abból a szempontból vállalt babának
									minősül, hogy további gyerek vállalása nélkül is jogosult lehetsz a támogatott
									kölcsönre.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<p>
								A családi otthonteremtési kedvezményt kizárólag gyermekvállalást tervező fiatal
								házaspárok igényelhetik. Akkor minősül fiatalnak a házaspár, ha a feleség igényléskor
								nem töltötte be a 41. életévét.
							</p>
							<p>
								2025. december 31-ig jogosult lehet a házaspár akkor is a támogatásra, ha a feleség
								betöltötte 41. életévét, és az igényléskor már legalább 12 hetes terhes.
							</p>
							<p>Élettársi kapcsolatban élők, egyedülállók a CSOK Plusz támogatásra nem jogosultak.</p>
							<h3>CSOK+ támogatás feltételei</h3>
							<ul>
								<li>
									Legalább 2 éves Tb-jogviszony szükséges, az elvárást elég a házaspár egyik tagjának
									teljesítenie.
								</li>
								<li>
									Az igénylést megelőző 180 napon belül szigorúbb elvárások vannak, ezen időszakban
									kizárólag a magyar alkalmazotti, vállalkozói jogviszony megfelelő. (Természetesen
									ezt is elég a házaspár egyik tagjának teljesítenie.)
								</li>
								<li>
									Azon magyar házaspárok is jogosultak a CSOK Pluszra, akik 2 éves külföldi
									Tb-jogviszonnyal rendelkeznek, de az igénylést követő 180 napon belül magyar
									jogviszonyt szükséges létesíteniük.
								</li>
								<li>
									Nem lehet büntetett előéletű az igénylő - a házaspár mindkét tagjára érvényes ez a
									feltétel.
								</li>
								<li>
									Az igénylőnek nem lehet NAV tartozása - a házaspár mindkét tagjára érvényes ez a
									feltétel.
								</li>
								<li>
									Lakásvásárlásnál az igénylést megelőző 180 napon belül kell megkötni az adásvételi
									szerződést.
								</li>
								<li>
									Lakásvásárlásnál a vételár legfeljebb 10 százalékát lehet készpénzben megfizetni.
								</li>
								<li>
									Használt lakás vásárlásánál a vételár legfeljebb 20 százalékkal térhet el az
									ingatlan értékbecslő által meghatározott forgalmi értékétől.
								</li>
								<li>
									Teljesíteni kell a lakás vagy ház minimális alapterületére vonatkozó elvárásokat (ez
									függ a gyermekek számától és az ingatlan típusától is).
								</li>
								<li>
									Az ingatlan vételára, építési költsége első közös lakás esetén nem haladhatja meg a
									80 millió forintot, egyéb esetben - nem első közös otthon - a 150 millió forint ot.
								</li>
								<li>
									Nem első közös otthon vásárlása esetén a korábbi ingatlan árát meg kell haladnia az
									újonnan a CSOK Pluszból vásárolt lakás árának. (Az igénylők korábban lakásban lévő
									tulajdoni hányadának értékét kell a vizsgálat során figyelembe venni, nem
									feltétlenül a teljes értéket.)
								</li>
							</ul>
							<p>
								Első közös lakásnak akkor minősül az ingatlanszerzés, amennyiben az igénylést megelőzően
								a házaspár tagjai nem rendelkeztek ugyanazon Magyarországon fekvő lakóingatlanban
								tulajdoni hányaddal. Vagyis közös tulajdonuk nem volt.
							</p>
							<p>
								<a href="/csok-feltetelei/?link_type=landing-faq" target="_blank">
									A CSOK Plusz feltételeiről kapcsolódó oldalunkon olvashatsz részletesen.
								</a>
							</p>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>Falusi CSOK a preferált kistelepüléseken</h3>
					<p>
						Meglévő és jövőben születendő gyermek(ek) után járó vissza nem térítendő lakáscélú állami
						támogatás. Kizárólag akkor igényelhető, ha a lakóingatlan preferált kistelepülésen fekszik.
					</p>
					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<ul>
								<li>
									használt lakásvásárlás és egyidejűleg bővítés/korszerűsítés
									<ul>
										<li>
											1 gyermekre <strong>1 millió Ft</strong>
										</li>
										<li>
											2 gyermekre <strong>4 millió Ft</strong>
										</li>
										<li>
											3 vagy több gyermekre <strong>15 millió Ft</strong>
										</li>
									</ul>
								</li>
								<li>
									Új lakóház vásárlása, építkezés
									<ul>
										<li>
											1 gyermekre <strong>1 millió Ft</strong>
										</li>
										<li>
											2 gyermekre <strong>4 millió Ft</strong>
										</li>
										<li>
											3 vagy több gyermekre <strong>15 millió Ft</strong>
										</li>
									</ul>
								</li>
								<li>
									meglévő ingatlan bővítése/korszerűsítése
									<ul>
										<li>
											1 gyermekre <strong>600 ezer Ft</strong>
										</li>
										<li>
											2 gyermekre <strong>2 millió Ft</strong>
										</li>
										<li>
											3 vagy több gyermekre <strong>7,5 millió Ft</strong>
										</li>
									</ul>
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>
								<strong>Bővítés:</strong> Meglévő lakás legalább egy lakószobával történő bővítése,
								amely során a hasznos alapterület is növekszik.
							</p>
							<p>
								<strong>Korszerűsítés:</strong> Meglévő ingatlanon végzett munkálatok, amelyek
								következtében a lakás állapota az eredeti, építéskori minőségét is meghaladhatja. (Az
								elfogadható munkálatokat a jogszabály tartalmazza.)
							</p>
							<p>
								<strong>Bővítés és korszerűsítés:</strong> A meglévő lakás legalább egy lakószobával
								bővül, és ezzel egyidőben a meglévő lakrészeket is korszerűsítik, felújítják.
							</p>
							<p>
								<strong>
									Használt lakás vásárlásával egyidőben történő korszerűsítés és/vagy bővítés:
								</strong>{" "}
								A CSOK támogatásról szóló jogszabály alapján használt lakásnak minősülő lakás vásárlása.
								Ebben az esetben a megvásárolt lakás korszerűsítésére, bővítésére is fel kell használni
								a támogatást.
							</p>
							<p>
								<strong>Lakóház építése:</strong> Alapozási munkálatoktól kezdődő egylakásos lakóépület
								- családi ház - építése finanszírozható a támogatásból.
							</p>
							<p>
								<strong>Új egylakásos lakóépület vásárlása:</strong> Újonnan, eladási célra épített
								lakóház vásárlására is fordítható a támogatás. Kizárólag kivitelező, vállalkozó által
								értékesített ingatlan finanszírozható, magánszemély által épített ház akkor sem felel
								meg az új lakás fogalmának, ha még nem lakott benne senki. Új lakóházakra vonatkozó
								elvárásnak az egylakásos lakóházak - jellemzően családi házak - felelnek meg,
								többlakásos lakóépületben lévő lakás megvásárlására nem fordítható a kedvezmény.
							</p>
							<p>A támogatás összege közvetlenül az adott lakáscélra fordítható.</p>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								Meglévő és vállalt gyermekre is lehet igényelni a támogatást, a CSOK Plusszal ellenben
								itt nem kell mindenképpen gyermeket vállalni a kedvezmény igényléséhez.
							</p>
							<p>A támogatás szempontjából gyermeknek minősül:</p>
							<ul>
								<li>Magzat, amennyiben betöltötte a terhesség 12. hetét.</li>
								<li>25. évnél fiatalabb vér szerinti és örökbefogadott gyermek.</li>
								<li>
									25. életévét betöltött gyermek, amennyiben megváltozott munkaképességűnek minősül.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<p>
								Házaspárok, élettársak és egyedülálló szülők is igényelhetik a Falusi CSOK támogatást.
								Vállalt gyermek után azonban csak olyan házaspárok kérhetik a konstrukciók, ahol a
								feleség nem töltötte be igényléskor a 41. életévét.
							</p>
							<h3>A falusi CSOK támogatás feltételei</h3>
							<p>A főbb feltételek hasonlóak a CSOK Plusz támogatáshoz kapcsolódó elvárásokkal. </p>
							<ul>
								<li>
									Legalább 2 éves Tb-jogviszony szükséges az igénylők egyikétől. Az igénylést megelőző
									180 napban a Tb-jogviszonynak már magyar alkalmazotti-vállalkozói jogviszonyból kell
									származnia.
								</li>
								<li>
									Elfogadható, ha a magyar állampolgár legalább 2 éves külföldi Tb-jogviszonyt igazol
									azzal a megkötéssel, hogy az igénylést követő 180 napon belül magyar Tb-jogviszonya
									kell legyen a kérelmezőnek.
								</li>
								<li>
									Egyik igénylőnek - házas-, illetve élettársak esetén mindkét félnek - sem lehet NAV
									tartozása és büntetlen előéletűnek kell lennie a kérelmezőknek.
								</li>

								<li>
									Lakásvásárlásnál az adásvételi szerződés megkötését követő 180 napon belül be kell
									nyújtani a támogatás iránti kérelmet.
								</li>

								<li>
									Lakásvásárlásnál a vételárnak legfeljebb a 10 százalékát lehet készpénzben
									megfizetni.
								</li>

								<li>
									Használt lakás vásárlásakor az értékbecslő által meghatározott forgalmi értéket
									legfeljebb 20%-kal haladhatja meg az ingatlan vételára.
								</li>

								<li>
									Kizárólag preferált kistelepülésen fekvő ingatlanokra igényelhető a támogatás.{" "}
									<a
										href="/mediatar/cikk/falusi-csok-2021-itt-a-bovitett-telepuleslista-megyek-szerinti-bontasban/?link_type=landing-faq"
										target="_blank"
									>
										Az érintett települések listája itt található.
									</a>
								</li>

								<li>
									Teljesíteni kell az ingatlan minimális alapterületére vonatkozó elvárásokat (ez függ
									a gyermekek számától és az ingatlan típusától is).
								</li>
							</ul>
							<p>
								<a href="/falusi-csok/?link_type=landing-faq" target="_blank">
									A Falusi CSOK feltételeiről részletesen itt olvashatsz.
								</a>
							</p>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>A Falusi CSOK mellé igényelhető 3%-os kamatozású, kedvezményes CSOK-hitel</h3>
					<p>
						A Falusi CSOK támogatás mellé kedvezményes CSOK-hitelt lehet igényelni, melynél a kölcsön
						lejáratáig fix 3 százalék a hitelkamat. A CSOK-hitel és a CSOK Plusz nem igényelhető egyszerre
						ugyanazon lakáscélra.
					</p>
					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<ul>
								<li>
									Falusi CSOK támogatással együtt új lakóház vásárlására, építkezésre, meglévő
									lakóingatlan korszerűsítésére, bővítésére, valamint használt ingatlan vásárlására és
									egyidejűleg bővítésre, korszerűsítésre
									<ul>
										<li>
											2 gyermekre maximum<strong>10 millió Ft</strong>
										</li>
										<li>
											3 vagy több gyermekre maximum <strong>15 millió Ft</strong> igényelhető.
										</li>
									</ul>
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>
								Falusi CSOK támogatás mellé új lakóház vásárlására, építésre, meglévő lakóingatlan
								korszerűsítésére, bővítésére, valamint használt ingatlan vásárlásával egyidejű
								korszerűsítésre és/vagy bővítésre lehet igényelni.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								Ezen támogatott kölcsön meglévő és vállalt gyermek után is kihasználható.Vagyis a CSOK
								Plusszal szembeni legnagyobb előnye, hogy ezt akkor is felveheted, ha nem szeretnél
								újabb gyereket.
							</p>
							<p>A támogatás szempontjából meglévő gyermeknek minősül:</p>
							<ul>
								<li>A várandósság 12. hetét betöltött magzat.</li>
								<li>A 25. életévét be nem töltött örökbefogadott és vér szerinti gyermek.</li>
								<li>A 25. életévét betöltött megváltozott munkaképességű személy.</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<p>
								Gyermeket nevelő házaspárok, élettársak és egyedülálló szülők is igényelhetik a
								támogatott hitelt. Vállalt gyermekre azonban csak fiatal házaspárok kérhetik a
								konstrukciót. (Fiatal házasoknál a feleség az igényléskor nem tölthette be a 41.
								életévét.)
							</p>
							<h3>CSOK-hitel feltételei</h3>
							<p>
								Legalább két gyermek után Falusi CSOK támogatást szükséges igényelni. Ez azt is jelenti,
								hogy meg kell felelni az igénylőnek a Falusi CSOK valamennyi elvárásának is.
							</p>
							<p>
								Nem elég a támogatás jogszabályi feltételeinek megfelelni. Hitelről van szó, ezért a
								banknak is hitelképesnek kell minősítenie az igénylőket.
							</p>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>Babaváró hitel és támogatás</h3>
					<p>
						Házaspárok által igényelhető, maximum <strong>11 millió Ft</strong> összegű,{" "}
						<strong>20 éves futamidejű szabadfelhasználású támogatott</strong> kölcsön. A hitel induló
						törlesztőrészlete maximum 51 ezer Ft lehet.
					</p>
					<Accordion>
						<LandingAccordion title="Milyen kedvezmények kapcsolódnak a kölcsönhöz?">
							<ul>
								<li>
									A hitel a futamidő első 5 évében kamatmentes, ráadásul a kedvezmény megmarad a
									kölcsön lejáratáig, amennyiben ezen 5 éves időszak alatt egy gyermeke születne a
									párnak.
								</li>
								<li>A második baba érkezésekor elengedik a fennálló tartozás 30 százalékát.</li>
								<li>A harmadik gyerek érkezésekor pedig elengedik a teljes fennálló tartozást.</li>
								<li>
									Az első és második baba születésekor a család kérheti törlesztési kötelezettségének
									3 éves szüneteltetését.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<p>
								Legfeljebb 11 millió forint összegű szabad felhasználású Babaváró hitel igényelhető. A
								bank hitelminősítése alapján derül ki, hogy ténylegesen mekkora összegre jogosult az
								igénylő pár.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>
								A Babaváró hitel egy szabad célú kölcsön, így az igénylő tetszőlegesen felhasználhatja a
								folyósított összeget. Számos pár azonban lakáscéljuk megvalósítására fordítja azt.
							</p>
							<p>
								Emellett azonban ideális lehet meglévő magas kamatú kölcsön kiváltására - a Babaváró
								hitelből előtörlesztik a meglévő kölcsönt -, autóvásárlásra is.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								A Babaváró hitel igénylésének nem feltétele, hogy gyermeke legyen a párnak, sőt babát
								vállalni sem szükséges.
							</p>
							<p>
								Ugyanakkor a konstrukcióhoz kapcsolódó támogatásoknak feltétele, hogy a párnak a
								futamidő alatt szülessen gyermeke.
							</p>
							<ul>
								<li>
									Az igénylést követő 5 évben született gyermek esetén a konstrukció a futamidő végéig
									kamatmentessé válik. Emellett kérheti a pár a törlesztőrészlet hároméves
									szüneteltetését is.
								</li>
								<li>
									Ha a futamidő alatt megszületik a második gyermek, akkor elengedik a tartozás
									30%-át. A törlesztés 3 éves szüneteltetését ekkor is kérheti a pár.
								</li>
								<li>A harmadik baba születésekor pedig elengedik a teljes fennálló tartozást.</li>
							</ul>
							<p>
								Kizárólag a Babaváró igénylését követően született, örökbefogadott gyermek számít az
								elérhető támogatások szempontjából. Az igényléskor már meglévő gyermekre nem jár
								kamatmentesség, tartozáselengedés.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<p>
								Kizárólag házaspárok igényelhetik a Babaváró hitelt, további feltétel, hogy a pár hölgy
								tagja az igényléskor még nem tölthette be 41. életévét.
							</p>
							<h3>Babaváró hitel feltételei</h3>
							<ul>
								<li>Kizárólag házaspárok igényelhetik a támogatást.</li>
								<li>
									A pár hölgy tagja nem tölthette be a 30. életévét. (2024. december 31-ig könnyítést
									adnak: olyan házaspárok is igényelhetik a támogatást, amelyeknél a házaspár hölgy
									tagja nem 30-40 év közötti. A könnyítés feltétele, hogy a feleség már minimum 12
									hetes terhes legyen.)
								</li>
								<li>Legalább 3 éves Tb-jogviszonyt kell igazolnia a házaspár egyik tagjának.</li>
								<li>
									Az igénylést megelőző 180 napnak magyar alkalmazotti, vállalkozói jogviszonynak kell
									lennie. (Amennyiben az igénylést megelőző 180. napon külföldi Tb-jogviszonyt igazol
									le az igénylő, akkor elégséges az igénylést megelőző 90 napnak magyar alkalmazotti,
									vállalkozói jogviszonynak lennie.)
								</li>
								<li>Nem lehet büntetett előéletű a házaspár egyik tagja sem.</li>
								<li>A pár egyik tagjának sem lehet köztartozása.</li>
								<li>Magyar lakcímmel kell rendelkeznie a házaspár mindkét tagjának.</li>
								<li>
									Nem szerepelhet a pár egyik tagja sem a rossz adósokat tartalmazó negatív KHR listán
									(régi nevén BAR lista). Akkor kerülhet fel az adós a negatív KHR listára, ha
									hitelével kapcsolatban legalább a minimálbért elérő elmaradása van és ez az állapot
									már legalább 90 napja fennáll.
								</li>
								<li>
									A pénzintézetnek hitelképesnek kell minősíteni az igénylőket - vagyis szükséges
									megfelelő jövedelem, munkaviszony stb.
								</li>
							</ul>
							<p>
								<a href="/erste-babavaro-hitel/?link_type=landing-faq" target="_blank">
									A Babaváró hitel és támogatás feltételeiről részletesen kapcsolódó oldalunkon
									tájékozódhatsz.
								</a>
							</p>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>Áfa-visszatérítés - építkezés, bővítés, korszerűsítés</h3>
					<p>
						Preferált kistelepülésen történő bővítés, korszerűsítés, építés költségeiről kiállított számlák
						27%-os áfája, de maximum 5 millió Ft visszaigényelhető.
					</p>
					<p>Az áfa-visszatérítési támogatás nem érhető el nagyobb településeken, városokban.</p>
					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<p>
								A korszerűsítési, bővítési, építési munkálatok számláinak áfatartalma igényelhető
								vissza, de legfeljebb 5 millió forint.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>Szakaszosan a kivitelezői munkálatokra lehet fordítani a kapott összeget.</p>
							<ul>
								<li>Korszerűsítésre, és/vagy bővítésre.</li>
								<li>Lakóház építésére is kérhető a kedvezmény.</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								Építkezésnél az áfa-visszaigényléshez nem kapcsolódik az igénylők gyermekeire vonatkozó
								elvárás.
							</p>
						</LandingAccordion>

						<h3>Az építkezéshez, korszerűsítéshez, bővítéshez kapcsolódó áfa-visszatérítés feltételei</h3>

						<ul>
							<li>Az ingatlan alapterülete ne haladja meg ház esetén a 300 négyzetmétert.</li>
							<li>Kizárólag 27 százalékos áfatartalmú számla után igényelhető vissza adó.</li>
							<li>
								Teljesíteni kell a Falusi CSOK-hoz kapcsolódó valamennyi személyi és ingatlanra
								vonatkozó feltételt.
							</li>
						</ul>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>Az új lakások vásárlásához kapcsolódó áfa kedvezmény 2025-ben is elérhető</h3>
					<p>
						A 150 négyzetmétert NEM meghaladó alapterületű újépítésű lakások és a 300 négyzetmétert NEM
						meghaladó alapterületű újépítésű házak vásárlása esetén a kedvezményes 5 százalékos lakásáfa
						továbbra is érvényben marad a 2026 végéig megkezdett építkezések esetén. Az új lakások vételára
						alapesetben 27%-os általános forgalmi adót tartalmaz, mely 5%-ra csökkent.
					</p>
					<p>Továbbá 5%-os az áfája a lakásépítéseknek is, amennyiben generálkivitelező építi a házat.</p>
					<p>
						Az 5 százalékos lakásáfát is vissza lehet igényelni preferált kistepelülésen, amennyiben Falusi
						CSOK támogatást is igényelt a család a vásárláshoz, építkezéshez.
					</p>
					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<ul>
								<li>
									Az áfacsökkentés automatikusan jár a megfelelő alapterületű új lakást vásárlóknak,
									építkezőknek. A kedvezmény nehezen számszerűsíthető, hiszen nem tudni, hogy magasabb
									áfa esetén a kivitelező mekkora összeget tudna áthárítani vevőjére.
								</li>
								<li>
									Az 5 százalékos áfa-visszaigénylés egy 60 millió forint vételárú lakóház esetében
									2,85 millió forint támogatást jelentene.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Mire használható a támogatás?">
							<p>
								A kedvezményes áfa kizárólag új építésű lakások vásárlásakor, illetve
								generálkivitelezővel történő építkezésnél érhető el.
							</p>
							<p>
								Az adó-visszatérítési támogatás kizárólag preferált kistelepülésen a 300 négyzetméternél
								kisebb alapterületű lakóházak, családi házak esetében érhető el.
							</p>
							<ul>
								<li>Az áfa csökkentése a vételárra, építési költségekre gyakorolhat hatást.</li>
								<li>
									Az áfa-visszaigénylésnél a vevő ténylegesen megkap egy összeget, melyet
									automatikusan a vételár részeként elutal az eladónak a pénzintézet.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<ul>
								<li>
									Nincs semmilyen gyermekekre vonatkozó feltétel az áfacsökkentéshez kapcsolódóan.
								</li>
								<li>
									Az áfa-visszaigénylésnek feltétele, hogy Falusi CSOK támogatást is igényeljen a
									vevő. Vagyis teljesíteni kell a kérdéses kedvezmény feltételeit: legalább egy
									meglévő, vagy vállalt gyermek szükséges.
								</li>
							</ul>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<ul>
								<li>
									Az áfacsökkentésére bárki jogosult lehet, aki megfelelő új lakást vásárol, vagy
									generál kivitelezővel építteti otthonát.
								</li>
								<li>
									Az áfa-visszaigénylésnél elvárás, hogy Falusi CSOK támogatást is igényeljen a vevő,
									vagyis teljesítenie kell az ott elvárt személyi feltételeket.
								</li>
							</ul>
							<h3>Az újépítésű lakás vásárlásához, építéséhez kapcsolódó áfakedvezmény feltételei</h3>
							<ol>
								<li>
									Áfacsökkenés:
									<ul>
										<li>Újépítésű lakást szükséges vásárolni, építtetni.</li>
										<li>
											Az ingatlan alapterülete nem haladhatja meg lakás esetén a 150
											négyzetmétert, míg ház esetén nem lehet nagyobb 300 négyzetméternél.
										</li>
										<li>A 2020. december 31. követően kifizetett számlákra érvényes.</li>
										<li>
											Építkezés esetén generálkivitelezővel szükséges az ingatlant legalább
											szerkezetkész állapotra felépíteni.
										</li>
									</ul>
								</li>
								<li>
									Áfa-visszatérítés:
									<ul>
										<li>Az 5 százalékos áfa igényelhető vissza.</li>
										<li>
											Legalább egy gyermek után igényelnie kell a vevőnek a Falusi CSOK támogatást
											is. Vagyis meg kell felelni azon kedvezményhez kapcsolódó valamennyi
											elvárásnak, előírásnak.
										</li>
										<li>
											Építkezésnél nem nyújtható be visszaigénylésnél 5 és 27%-os áfatartalmú
											számla egyidejűleg.
										</li>
									</ul>
								</li>
							</ol>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
				<LandingContainer className="details">
					<h3>Illetékmentesség lakásvásárláskor - 2025-ben is elérhető</h3>
					<p>
						A{" "}
						<a href="/csok-feltetelei/?link_type=landing-faq" target="_blank">
							CSOK Plusz támogatás
						</a>{" "}
						felhasználásával vásárolt ingatlanok (új és használt is) vagyonszerzési illetékét nem kell
						megfizetni, amelynek összege jelenleg a vételár 4 százaléka.
					</p>
					<p>
						Ugyanúgy illetékmentes a lakásvásárlás a Falusi CSOK kedvezménnyel megszerzett újépítésű és
						használt lakóházak esetében is.
					</p>
					<Accordion>
						<LandingAccordion title="Mekkora összeg igényelhető?">
							<p>
								<a
									href="/mediatar/cikk/millios-kiadast-jelenthet-mar-egy-atlagos-lakas-utan-fizetendo-illetek-is/?link_type=landing-faq"
									target="_blank"
								>
									Alapesetben a vételár 4%-a az illeték
								</a>{" "}
								- ha nem kapcsolódik hozzá kedvezmény - lakásvásárlás esetén, amit nem szükséges
								megfizetni. Ez egy 60 millió forint összegű lakásvásárlás esetén 2,4 millió forint
								illetékelengedést jelentene.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Ki minősül gyermeknek?">
							<p>
								CSOK Pluszt, vagy Falusi CSOK támogatást szükséges igényelni az illetékmentességhez,
								vagyis a gyermekekre vonatkozó elvárások megegyeznek az ott leírtakkal.
							</p>
						</LandingAccordion>
						<LandingAccordion title="Ki igényelheti a támogatást?">
							<p>
								Az illetékmentesség feltétele, hogy CSOK Pluszt, vagy Falusi CSOK támogatást - akárcsak
								egy gyermek után is - igényeljen a lakásvásárláshoz a vevő. Vagyis preferált
								kistelepülések esetén egyedülállók, házaspárok, élettársak is jogosultak lehetnek a
								támogatásra, amennyiben Falusi CSOK támogatást is igényeltek.
							</p>
							<p>
								Ugyanakkor a nagyobb településeken már csak azon házaspárok esetében érhető el az
								illetékmentesség, akik gyermeket vállalnak és kihasználják a CSOK Pluszt is.
							</p>
							<h3>Illetékmentesség támogatás feltételei</h3>
							<ul>
								<li>Használt, vagy újépítésű lakás vásárlása.</li>
								<li>
									Legalább egy gyermek után CSOK Plusz, vagy Falusi CSOK igénylése. Vagyis valamennyi
									személyi és ingatlanra vonatkozó feltételét teljesíteni kell a kérdéses
									kedvezménynek.
								</li>
							</ul>
						</LandingAccordion>
					</Accordion>
				</LandingContainer>
			</>
		);
	}
}
